import { h, ComponentChild } from 'preact'

type Props = {
  image?: ComponentChild,
  children: ComponentChild,
  action?: ComponentChild
}

const SimplePanel = ({ image, children, action }: Props) => {
  return (
    <div class='simple-panel'>
      {image && <div className='simple-panel__image'>
        {image}
      </div>}
      <div class='simple-panel__text'>
        {children}
      </div>
      {action && <div className='simple-panel__action'>
        {action}
      </div>}
    </div>
  )
}

export default SimplePanel
